module.exports = __webpack_public_path__ + "img/eservices-gov-ss.svg-light.7fca5cca.svg";